<template>
  <v-card variant="outlined" class="mb-4">
    <v-toolbar color="indigo" density="compact">
      <v-icon class="ml-4">mdi-earth</v-icon>
      <v-toolbar-title>Servicii Suplimentare</v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <v-alert v-if="mvnoPending" type="warning" density="compact" class="mb-3">
        <v-icon start>mdi-clock-outline</v-icon>
        SIM-ul asteapta confirmarea unei comenzi MVNO. Butoanele sunt blocate.
      </v-alert>

      <v-row>
        <v-col v-for="svc in supplementaryServices" :key="svc.name" cols="12" sm="6" md="4">
          <v-card
            :variant="svc.active ? 'elevated' : 'outlined'"
            :color="svc.active ? 'indigo-lighten-5' : undefined"
            :class="{ 'border-indigo': svc.active }"
            class="pa-3"
          >
            <div class="d-flex align-center justify-space-between">
              <div>
                <div class="text-subtitle-1 font-weight-bold">{{ serviceLabel(svc.name) }}</div>
                <div class="text-caption text-grey-darken-1">{{ svc.name }}</div>
              </div>
              <v-switch
                :model-value="svc.active"
                color="indigo"
                density="compact"
                hide-details
                :loading="togglingService === svc.name"
                :disabled="mvnoPending || (togglingService !== null && togglingService !== svc.name)"
                @update:model-value="toggleService(svc)"
              />
            </div>
            <div v-if="svc.activated_at" class="text-caption text-grey mt-1">
              Activat: {{ formatDate(svc.activated_at) }}
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { defineComponent } from 'vue'
import { toggleNetworkService } from '@/composables/useNetworkServicesAPI'
import store from '@/store'

export default defineComponent({
  name: 'SimInternationalPanel',
  props: {
    simId: { type: [Number, String], required: true },
    services: { type: Array, default: () => [] },
    mvnoPending: { type: Boolean, default: false }
  },
  emits: ['service-toggled'],
  data() {
    return {
      togglingService: null
    }
  },
  computed: {
    supplementaryServices() {
      const allowed = ['S2', 'S3', 'S6']
      return this.services.filter(s => allowed.includes(s.name))
    }
  },
  methods: {
    async toggleService(svc) {
      this.togglingService = svc.name
      const token = store.getters.getToken
      const result = await toggleNetworkService(token, this.simId, svc.name)
      this.togglingService = null

      if (!result.error) {
        this.$emit('service-toggled', { productCode: svc.name, active: result.active, message: result.message })
      } else {
        this.$emit('service-toggled', { productCode: svc.name, error: true, message: result.message })
      }
    },
    serviceLabel(name) {
      const labels = { 'S2': 'International', 'S3': '4G', 'S6': '2G' }
      return labels[name] || name
    },
    formatDate(d) {
      if (!d) return ''
      return new Date(d).toLocaleString('ro-RO', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    }
  }
})
</script>

<style scoped>
.border-indigo {
  border: 2px solid #3F51B5 !important;
}
</style>
